export const CHART_TYPES = [
  { key: "candles", label: "Candles" },
  { key: "bars", label: "Bars" },
  { key: "line", label: "Line" },
  { key: "area", label: "Area" },
  { key: "baseline", label: "Baseline" },
] as const;

export type ChartType = (typeof CHART_TYPES)[number]["key"];
